module.exports = __webpack_public_path__ + "img/uabc_correo.96f15a39.png";